import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import ResponsiveImage from '../../../components/responsive-image'
import productCategorySelect from '../../../helpers/analytics-utils/product-category-select'
import style from './index.module.scss'

const SubRowCategory = ({ id, name, link, image, alt }) => (
  <div className={classNames(style.category, style.categoryMid)}>
    <Link
      className={style.categoryLink}
      to={link}
      onClick={() => productCategorySelect(id, name)}
    >
      <ResponsiveImage
        className={style.image}
        desktopImageUrl={image}
        mobileImageUrl={image}
        mobileRatio="standard"
        desktopRatio="standard"
        alt={alt}
        numberOfItems={3}
      />
      <h2 className={classNames(style.categoryHeader, style.categoryHeaderMid)}>
        {name}
      </h2>
    </Link>
  </div>
)

SubRowCategory.propTypes = {
  name: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
}

export default SubRowCategory
